module.exports = __webpack_public_path__ + "assets/img/detail4.f04e486c.png";